<template>
  <div class="atom-loader__withOverlay d-flex flex-column">
    <AtomLoader />
    <span class="mt-1 atom-loader__withOverlay__text">
      {{ $filters.firstUpper(loaderTitle) }}
    </span>
  </div>
</template>

<script>
import AtomLoader from "@/components/loader"

export default {
  components: {
    AtomLoader
  },
  props: ["loaderTitle"]
}
</script>
